import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
const faqs = [{
  question: 'How soon will I see results?',
  answer: "Most people feel a shift in their energy and 'internal calm' within 48 hours. Midsection 'de-puffing' typically begins within 7-10 days."
}, {
  question: 'Do I need to buy expensive supplements?',
  answer: 'No. While we recommend basic minerals like Magnesium, the core of this system is based on physiological movements and common grocery items.'
}, {
  question: 'Is this a Keto or Low-Carb diet?',
  answer: 'No. In fact, we teach you why strategic complex carbs are necessary for lowering cortisol at night.'
}, {
  question: 'Will this help with my 3 AM wake-ups?',
  answer: "Yes. That is the primary problem this manual was designed to solve by fixing your 'Liver Alarm' response."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 bg-slate-800/50" data-id="element-272">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <ScrollFadeIn data-id="element-274">
          <div className="text-center mb-12" data-id="element-275">
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50 mb-4" data-id="element-276">
              Frequently Asked Questions
            </h2>
          </div>
        </ScrollFadeIn>

        <div className="space-y-4" data-id="element-277">
          {faqs.map((faq, index) => <ScrollFadeIn key={index} delay={index * 0.1} data-id="element-278">
              <div className="border border-slate-700 rounded-xl overflow-hidden bg-slate-900" data-id="element-279">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-280">
                  <span className="text-lg font-medium text-slate-50" data-id="element-281">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-282">
                    <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-283" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-284">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-285">
                      <div className="px-6 pb-6 text-slate-400 leading-relaxed border-t border-slate-800 pt-4" data-id="element-286">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}